import { lazy, Suspense, useState } from 'react'
import { Routes, Route } from 'react-router-dom'
import Header from './components/common/Header'
import Sidebar from './components/common/Sidebar'
import Loading from './components/common/Loading'

// Lazy load pages for code splitting
const HomePage = lazy(() => import('./pages/HomePage'))
const StatePage = lazy(() => import('./pages/StatePage'))
const PoliticianPage = lazy(() => import('./pages/PoliticianPage'))
const StateLegislatorPage = lazy(() => import('./pages/StateLegislatorPage'))
const StateBillPage = lazy(() => import('./pages/StateBillPage'))
const TickerPage = lazy(() => import('./pages/TickerPage'))
const LobbyingPage = lazy(() => import('./pages/LobbyingPage'))
const FinancePage = lazy(() => import('./pages/FinancePage'))
const BudgetPage = lazy(() => import('./pages/BudgetPage'))
const AgencyBudgetPage = lazy(() => import('./pages/AgencyBudgetPage'))
const AboutPage = lazy(() => import('./pages/AboutPage'))
const SearchPage = lazy(() => import('./pages/SearchPage'))
const BillsPage = lazy(() => import('./pages/BillsPage'))
const BillDetailPage = lazy(() => import('./pages/BillDetailPage'))
const LoginPage = lazy(() => import('./pages/LoginPage'))
const RegisterPage = lazy(() => import('./pages/RegisterPage'))
const VerifyEmailPage = lazy(() => import('./pages/VerifyEmailPage'))
const WatchlistPage = lazy(() => import('./pages/WatchlistPage'))
const SettingsPage = lazy(() => import('./pages/SettingsPage'))
const EmbedsLandingPage = lazy(() => import('./pages/EmbedsLandingPage'))
const NotFoundPage = lazy(() => import('./pages/NotFoundPage'))

function App() {
  const [sidebarOpen, setSidebarOpen] = useState(false)

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50 focus:bg-blue-600 focus:text-white focus:px-4 focus:py-2 focus:rounded"
      >
        Skip to main content
      </a>
      <Header onMenuClick={() => setSidebarOpen(true)} />
      <div className="flex">
        <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        <main id="main-content" className="flex-1 p-6 text-gray-900 dark:text-gray-100">
          <Suspense fallback={<Loading message="Loading..." />}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/state/:stateCode" element={<StatePage />} />
              <Route path="/politician/:id" element={<PoliticianPage />} />
              <Route path="/state-legislator/:id" element={<StateLegislatorPage />} />
              <Route path="/state-bill/:id" element={<StateBillPage />} />
              <Route path="/ticker/:ticker" element={<TickerPage />} />
              <Route path="/lobbying" element={<LobbyingPage />} />
              <Route path="/finance" element={<FinancePage />} />
              <Route path="/budget" element={<BudgetPage />} />
              <Route path="/budget/agency/:code" element={<AgencyBudgetPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/search" element={<SearchPage />} />
              <Route path="/bills" element={<BillsPage />} />
              <Route path="/bills/:id" element={<BillDetailPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/verify-email" element={<VerifyEmailPage />} />
              <Route path="/watchlist" element={<WatchlistPage />} />
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/embeds" element={<EmbedsLandingPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </Suspense>
        </main>
      </div>
    </div>
  )
}

export default App
